import {Redirect} from 'react-router-dom';

export const AdminIndex = () => {
  return <Redirect to="/admin/jk_user" />;
};

export default AdminIndex;
